import React from 'react';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import { AdServerData } from 'models/interfaces';

const LIST_ADSERVERS_QUERY = gql`
  query ListAdServers {
    adServers {
      ad_server_id
      name
      description
    }
  }
`;

interface AdServerContainerRenderProps {
  data?: AdServerData;
}

interface AdserverListContainerProps {
  children: (props: AdServerContainerRenderProps) => any;
}

// class AdServerQuery extends Query<AdServerData, any> {}

const AdServerContainer: React.FunctionComponent<AdserverListContainerProps> = ({
  children,
  ...props
}) => (
  <Query<AdServerData, any> query={LIST_ADSERVERS_QUERY} fetchPolicy={'no-cache'}>
    {({ data, loading, error, refetch }) => {
      if (loading || error) {
        return null;
      }
      refetch();
      return (
        children &&
        children({
          ...props,
          data
        })
      );
    }}
  </Query>
);

export default AdServerContainer;
